








































































































































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import LocalStore from '@/helpers/localstore'
import TimeAssistant from '@/helpers/time-assistant'
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */
import { IConvosOutputHistoryv12 } from '@/api/types/response.types'

/* API */

export default Vue.extend({
  name: 'ConversationDetailHeaderMessage',

  props: {
    creationEvent: {
      type: Object as () => IConvosOutputHistoryv12,
      required: true,
    },
  },
  data() {
    return {
      TimeAssistant,
      ColorAssistant,
      internalMessage: '',
      messageEditing: false,
      defaultToHtmlDescription: false,
      showMoreOptions: false,
    }
  },
  computed: {
    hasStylizedHtmlDescription(): boolean {
      return (
        this.creationEvent.stylizedHtmlVersionLink !== null &&
        this.creationEvent.stylizedHtmlVersionLink.trim() !== ''
      )
    },
    showingHtmlDescription(): boolean {
      return this.hasStylizedHtmlDescription && this.defaultToHtmlDescription
    },
    hidingHtmlDescription(): boolean {
      return this.hasStylizedHtmlDescription && !this.defaultToHtmlDescription
    },
    avatarSize(): number {
      if (this.$screen.isDesktop(this.$mq)) {
        return 40
      }
      if (this.$screen.isTabletOrMobile(this.$mq)) {
        return 24
      }
    },
    hasAttachments(): boolean {
      return this.creationEvent.attachments.length > 0
    },
    hasCCs(): boolean {
      return (
        this.creationEvent.ccs !== null && this.creationEvent.ccs.length > 0
      )
    },
    hasBounceInfo(): boolean {
      return this.creationEvent.bounceInfo !== null
    },
    hasOtherInfo(): boolean {
      return (
        this.hasAttachments ||
        this.hasCCs ||
        this.hasBounceInfo ||
        this.creationEvent.autoResponseSent
      )
    },
  },

  watch: {
    creationEvent: {
      immediate: true,
      handler(event: IConvosOutputHistoryv12) {
        this.internalMessage = event.description
      },
    },
  },

  mounted() {
    this.defaultToHtmlDescription =
      LocalStore.defaultToHtmlDescriptionOnConvoDetail
  },

  methods: {
    handleMouseEnter() {
      if (!this.$screen.isMobile(this.$mq)) {
        this.showMoreOptions = true
      }
    },
    handleMouseLeave() {
      if (!this.$screen.isMobile(this.$mq)) {
        this.showMoreOptions = false
      }
    },
    closeOptions() {
      this.showMoreOptions = true
      this.$nextTick(() => {
        this.showMoreOptions = false
      })
    },
    enableMessageEdit() {
      this.messageEditing = true
    },
    disableMessageEdit() {
      this.messageEditing = false
    },
    setDefaultToHtmlDescription() {
      this.closeOptions()
      this.messageEditing = false
      LocalStore.defaultToHtmlDescriptionOnConvoDetail = true
      this.defaultToHtmlDescription = true
    },
    removeDefaultToHtmlDescription() {
      this.closeOptions()
      this.messageEditing = false
      LocalStore.defaultToHtmlDescriptionOnConvoDetail = false
      this.defaultToHtmlDescription = false
    },
    initiateLinkedTask(id: Number) {
      // This vuex prop is being watched by the task/convo detail header
      this.$store.set('app/itemEventForLinkedTaskID', id)
    },
    updateIncomingMessage() {
      this.messageEditing = false
      if (this.creationEvent.description !== this.internalMessage) {
        this.$emit('update-incoming-message', this.internalMessage)
      }
    },
  },
})
